module.exports = __webpack_public_path__ + "static/media/snowmobile.18b4951c.svg";